import { render } from "./modal-camera.vue?vue&type=template&id=64771b2b&scoped=true&ts=true"
import script from "./modal-camera.vue?vue&type=script&lang=ts"
export * from "./modal-camera.vue?vue&type=script&lang=ts"

import "./modal-camera.vue?vue&type=style&index=0&id=64771b2b&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64771b2b"]])

export default __exports__